import { gql } from '@apollo/client'

export const START_CUSTOM_THUMBNAIL_UPLOAD = gql`
    mutation StartCustomThumbnailUpload($input: CustomThumbnailUploadInput!) {
        startCustomThumbnailUpload(input: $input) {
            success
            upload {
                id
                upload_status
                upload_progress
                uploaded_size
                file_size
                error_message
            }
            error
        }
    }
`

export const GET_CUSTOM_THUMBNAIL_UPLOAD = gql`
    query GetCustomThumbnailUpload($id: ID!) {
        CustomThumbnailUpload {
            customThumbnailUpload(id: $id) {
                id
                upload_status
                upload_progress
                uploaded_size
                thumbnail_url
                error_message
                file_name
                file_size
                width
                height
            }
        }
    }
`

export const GET_CUSTOM_THUMBNAIL_BY_ASSET = gql`
    query GetCustomThumbnailByAsset($adCreativeAssetId: ID!) {
        CustomThumbnailUpload {
            customThumbnailUploadByAssetId(adCreativeAssetId: $adCreativeAssetId) {
                id
                upload_status
                upload_progress
                uploaded_size
                thumbnail_url
                error_message
                file_name
                file_size
                width
                height
            }
        }
    }
`

export const DELETE_CUSTOM_THUMBNAIL_UPLOAD = gql`
    mutation DeleteCustomThumbnailUpload($id: ID!) {
        deleteCustomThumbnailUpload(id: $id)
    }
`

export const CANCEL_CUSTOM_THUMBNAIL_UPLOAD = gql`
    mutation CancelCustomThumbnailUpload($id: ID!) {
        cancelCustomThumbnailUpload(id: $id)
    }
`

export const COPY_CUSTOM_THUMBNAIL_TO_ASSET = gql`
    mutation CopyCustomThumbnailToAsset($adCreativeAssetId: ID!) {
        copyCustomThumbnailToAsset(adCreativeAssetId: $adCreativeAssetId)
    }
`
